import { ViewChild, Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { AuditService } from '../../../services/audit.service';
import {SearchService} from '../../../services/search.service';
import { CdkDetailRowDirective } from '../../../directives/cdk-detail-row.directive';
import { MatTabChangeEvent } from '@angular/material';
import { DoubleRowPaginatorComponent } from '../../double-row-paginator/double-row-paginator.component';
import { ActivatedRoute } from '@angular/router';
import { constants } from 'src/app/constants';

@Component({
  selector: 'app-audit-component',
  templateUrl: './audit-component.component.html',
  styleUrls: ['./audit-component.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AuditComponentComponent {
  displayedColumns = [];
  dataSource= [];
  order: string;

  auditCategory: any;
  auditCategoryHeader: any;
  previousSelectedData: any;
  activeTab: any;
  expandedElement: null;
  loadComponent = false;
  externalApplication = false;
  itemCount: number;
  selectedApplication: string;
  selectedOrganization: string;
  selectedLayout: string;
  selectedSmartName: string;
  showItem: string;
  selectedDomain: string;
  categoryList: any;
  categoryItems: any;
  queryParams: any;
  selectedCategoryItem: any;

  constructor(public searchService: SearchService, public auditService: AuditService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(param => {
      this.queryParams = param;
      this.externalApplication = (param['ex'] == 'true');
      this.selectedApplication = (param['app']);
      this.selectedOrganization = (param['organization']);
      this.selectedLayout = (param['layoutcode']);
      this.selectedSmartName = (param['smartname']);
      this.showItem = (param['showitem']);
      this.selectedDomain = (param['domain']);
    });
   }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort : MatSort;
  @ViewChild(DoubleRowPaginatorComponent) customPaginator: DoubleRowPaginatorComponent;
  
  isExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  @Input() singleChildRowDetail: boolean;
  @Input() searchParams: any;

  
  ngOnInit() {
    this.searchService.selectedIndex = 0; // Set the first tab as the selected TAB
    this.selectedCategoryItem = this.auditService.itemDataSource[this.searchService.selectedIndex];
    if (this.externalApplication) {
      this.searchService.searchData.selectedApplication = this.selectedApplication;
      this.searchService
        .getApplicationCategories(this.searchService.searchData.selectedApplication)
        .subscribe(catListData => {
          this.categoryList = catListData;
          this.categoryList.data.categories.forEach(catItem => {
            if (!this.showItem) {
              this.searchService.searchData.selectedCategories.push(catItem.code);
              this.searchService.searchData.selectedCategoryNames.push(catItem.description);
            } else {
              if (catItem.code === constants[this.selectedApplication][this.showItem.toUpperCase()]) {
                this.searchService.searchData.selectedCategories.push(catItem.code);
                this.searchService.searchData.selectedCategoryNames.push(catItem.description);
              }
            }
          });
          if(this.searchService.searchData.selectedCategories) {
            this.searchService.searchData.selectedCategories.forEach(categoryName => {
              if (categoryName) {
                this
                  .auditService
                  .getAuditCategoryHeading(categoryName)
                  .subscribe(data => {
                    this.categoryItems = data;
                    this.categoryItems.params = {};
                    this.categoryItems.data.itemFilters.forEach(filterItems => {
                      this.route.queryParams.subscribe((param)=> {
                        if(param[filterItems.name.toLowerCase()]) {
                          this.categoryItems.params[filterItems.name] = param[filterItems.name.toLowerCase()];
                        }
                      });
                    });
                    this.searchService.categoryItems.push(data);
                    this.getCategoryHeadings();
                    this.getAuditCategories();
                });
              }
            });
          }
      });
    } else {
      this.getCategoryHeadings();
      this.getAuditCategories();
    }
  }

  ngAfterViewInit() {
    this.loadTableViewChild();
  }

  loadTableViewChild() {
    if (this.auditCategory && this.auditCategory.data.items) {
      this.selectedCategoryItem.paginator = this.paginator;
      this.itemCount = this.auditCategory.data.items.length;
    }
  }
  /************
   * Function to sort the table either in ASC - Ascending or DSC - Desending or no sort
   * @param: filedName - Name of the field on which the sort should apply
   * ********************** */
  sortTable(event: any, fieldName: any) {
    var thisItemData = this.searchService.categoryItems[this.searchService.selectedIndex];
    // logic to set the sorting order
    if (thisItemData.params.sortby === fieldName) {
      if (thisItemData.params.order === 'asc') {
        thisItemData.params.order = 'dsc';
      } else if (thisItemData.params.order === 'dsc') {
        thisItemData.params.order = '';
      } else {
        thisItemData.params.order = 'asc';
      }
    } else {
      thisItemData.params.order = 'asc';
    }
    thisItemData.params.sortby = fieldName;
    this.getAuditCategories();
  }

  /*********
   * function to filer the item categories.
   * @param: fieldName - Name of filed for which the filter should apply
   * 
   * *********** */
  filterRows(event: any, filedName: any) {
    var thisItemData = this.searchService.categoryItems[this.searchService.selectedIndex];
    if (event.target.value) {
      this.route.queryParams.subscribe((param)=> {
        if(!param[filedName]) {
          thisItemData.params[filedName]=event.target.value;
        }
      });
    } else {
      this.route.queryParams.subscribe((param)=> {
        if(!param[filedName]) {
          delete thisItemData.params[filedName];
        }
      });
    }
    this.getAuditCategories();
  }

  /*
  * function to enable or disable the TEXT box
   */
  isTextBoxDisabled (columnName: string) {
    this.route.queryParams.subscribe((param)=> {
      if(param[columnName.toLowerCase()]) {
        return true;
      }
    });
  }

  getAuditCategories = (): void => {
    if (this.searchService.categoryItems[this.searchService.selectedIndex]) {
      if (!this.searchService.categoryItems[this.searchService.selectedIndex].params) {
        this.searchService.categoryItems[this.searchService.selectedIndex].params = {}
      }
      this
        .auditService
        .getAuditCategory(this.searchService.searchData, this.searchService.categoryItems, this.searchService.selectedIndex)
        .subscribe(data => {
          this.auditCategory = data;
          this.auditService.itemData[this.searchService.selectedIndex] = this.auditCategory.data.items;
          this.selectedCategoryItem = new MatTableDataSource(this.auditCategory.data.items);
          this.selectedCategoryItem.paginator = this.paginator;
          this.auditService.itemDataSource[this.searchService.selectedIndex] = this.selectedCategoryItem;
      });
    }
  };

  getCategoryHeadings = (): void => {
    if (this.searchService.categoryItems[this.searchService.selectedIndex]) {
      if (!this.searchService.categoryItems[this.searchService.selectedIndex].params) {
        this.searchService.categoryItems[this.searchService.selectedIndex].params = {}
      }
      this
        .auditService
        .getAuditCategoryHeading(this.searchService.categoryItems[this.searchService.selectedIndex].data.category.code)
        .subscribe(data => {
          let auditCategoryHeaderData: any;
          auditCategoryHeaderData = data;
          let thisCategoryHeading = [];
          for (let i = 0; i < auditCategoryHeaderData.data.itemFilters.length; i++) {
            thisCategoryHeading.push(auditCategoryHeaderData.data.itemFilters[i].name)
          }
          this.auditService.itemDisplayedColumns[this.searchService.selectedIndex] = thisCategoryHeading;
      });
    }
  };

  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.searchService.selectedItem = null;
    this.searchService.selectedItemIndex = null;
    this.expandedElement = null;
    this.searchService.selectedIndex = tabChangeEvent.index;
    this.selectedCategoryItem = this.auditService.itemDataSource[this.searchService.selectedIndex];
    if (!this.auditService.itemDisplayedColumns[this.searchService.selectedIndex]) {
      this.getCategoryHeadings();
    }

    if (!this.auditService.itemDataSource[this.searchService.selectedIndex]) {
      this.getAuditCategories();
    }
    setTimeout(() => {
      this.loadTableViewChild();
    }, 1000);
    
  }

  expandCollapseEvents = (ele: any, index: any): void => {
    this.loadComponent = false;
    this.selectedCategoryItem = new MatTableDataSource(this.auditService.itemData[this.searchService.selectedIndex]);
    this.searchService.selectedItem = ele;
    this.searchService.selectedItemIndex = index;
    this.expandedElement = this.expandedElement === ele ? null : ele;
    this.selectedCategoryItem.paginator = this.paginator;
    setTimeout(x=>this.loadComponent=true);
  }
  private openedRow: CdkDetailRowDirective
  onToggleChange(cdkDetailRow: CdkDetailRowDirective,row: any, index: any) : void {
    this.selectedCategoryItem = new MatTableDataSource(this.auditService.itemData[this.searchService.selectedIndex]);
    this.searchService.selectedItem = row;
    this.searchService.selectedItemIndex = index;
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expanded) {
      this.openedRow.toggle();
    }
    row.close = !(row.close);
    this.openedRow = cdkDetailRow.expanded ? cdkDetailRow : undefined;
  }
}